export const DASHBOARD_TEMPLATE_FILTER_PRESETS = {
	dashboard: {
		ariaLabel: 'Dashboard filters',
		skipLinkId: 'dashboard-filters-section',
		className: 'dashboard-filters',
		hasTextFilter: false,
		forceRemountOnFilterChange: false
	},
	issues: {
		ariaLabel: 'Issues filters',
		skipLinkId: 'issues-filters-section',
		className: 'issues-filters',
		hasTextFilter: true,
		forceRemountOnFilterChange: true
	}
} as const;
